// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QEIx","label":"styles_label__1rJnX"};